








































































































































































import { namespace } from 'vuex-class';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import { AcgnFormTitle, AcgnFormContent } from '@/components';
import AcgnStaffCake from './staff-cake.vue';
import { Tooltip, DatePicker, RadioGroup, RadioButton } from 'element-ui';
import { creatTitles } from '@/constants/type-helper';
import { getUID } from '@/util';
import dayjs from 'dayjs';
import { openUrl } from '@/util';
import { statisticChartColors } from '@/constants/type-helper';

const StatisticNorAction = namespace('desk/statisticNor').Action;
const StatisticAction = namespace('desk/statistic').Action;
const StaffAction = namespace('desk/staff').Action;

const AuthGetter = namespace('desk/auth').Getter;
const CommGetter = namespace('desk/comm').Getter;
const StaffGetter = namespace('desk/staff').Getter;

@Component({
  components: {
    AcgnFormTitle,
    AcgnFormContent,
    AcgnStaffCake,
    [Tooltip.name]: Tooltip,
    [DatePicker.name]: DatePicker,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
  },
})

/**
 * 项目图表
 */
export default class AcgnStatisticChart extends Vue {
  public name: string = 'AcgnStatisticChart';

  @Prop({ default: true }) public isShowDiff: string; // 是否显示对比成员
  @Prop({ default: null }) public comicId: number | null; // 项目id (有项目id才有目标进度)
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  // 1：创作方统计，2：管理方统计
  @Prop({ default: 1 }) public type: number; // 用于区分请求数据接口

  // 如管理方内嵌的创作方需要此标识，用户筛选条件展示
  @Prop({ default: false }) public isExternal: boolean; // 是否扩展显示

  @StatisticNorAction private getCreationChartData: any; // 创作方图表
  @StatisticAction private getAdminChartData: any; // 管理方图表
  @StatisticNorAction private getLinkList: any; // 获取创作环节
  @StatisticAction private getAdminLinkList: any; // 获取创作环节(管理方)

  @CommGetter private attributeData: any; // 公共类型

  private apiKey: any = {
    1: 'getLinkList',
    2: 'getAdminLinkList'
  };
  private apiKeyData: any = {
    1: 'getCreationChartData',
    2: 'getAdminChartData'
  };
  private apiUrls: any = {
    1: 'v1/datastatistics/getchartdata',
    2: 'v1/datastatistics/getadminchartdata'
  };

  private formData: any = {
    data_type: null, // 创作类型
    link_id: null, // 创作环节
    task_status: null, // 任务组状态
    is_expect: null, // 逾期状态
    status: null, // 审批类型
    date_type: 1, // 统计范围
    start_time: '', // 开始时间
    end_time: '' // 结束时间
  };

  private tabPosition: string = '1'; // 显示数据类型数据还是件数据
  private chartData: any = null; // 图标数据
  private linkList: any = []; // 创作环节
  private staffIdMap: any = {}; // 对比成员map
  private staffIds: any = []; // 对比员工数组
  private chartId = getUID();
  private searching = false; // 是否正在请求图表数据

  private watchItems = [
    'formData.data_type', 'formData.link_id', 'formData.task_status',
    'formData.is_expect', 'formData.status', 'formData.date_type',
    'formData.start_time', 'formData.end_time'];

  private colors: any = statisticChartColors;

  private pickerOptions: any = {
    disabledDate(time: any) {
      // return time.getTime() > Date.now() - 8.64e7;
    }
  };
  private timeRange: any = [];
  private chartInstance: any; // 表格实例

  // 是否管理方图表操作选项
  private get isRealComicSelection() {
    return this.type === 2 && !this.isExternal;
  }

  private get switchTitle() {
    return creatTitles[this.formData.data_type];
  }

  get timeOperate() {
    return this.formData.date_type === 1 ? 'week' : 'month';
  }

  // 折线图显示文案
  private get defaultTitle() {
    if (this.tabPosition === '2') {
      return '件数';
    }
    return this.switchTitle;
  }

  // 创作类型
  private get dataTypes() {
    return this.attributeData.chart.data_type;
  }
  // 任务状态
  private get comicStatuss() {
    return this.attributeData.chart.task_type;
  }

  // 逾期状态
  private get delayTypes() {
    if (this.formData.data_type !== 3) { // 任务组+任务
      return this.attributeData.chart.is_expect;
    }
    if (this.isRealComicSelection) { // 创作环节-管理方
      return this.attributeData.chart.expect_status;
    }
    // 创作环节-创作方
    return this.attributeData.chart.is_expect;
  }

  // 统计范围
  private get chartScopeTypes() {
    return this.attributeData.chart.date_type;
  }

  // 审批类型
  private get auditTypes() {
    return this.attributeData.chart.status;
  }

  @Watch('userId')
  private userIdChange() {
    this.search();
  }

  private async created() {
    this.formData.data_type = this.isRealComicSelection ? 1 : 3;
    this.setInitTimeRange();
    this.initWatch();
    this.linkList = (await (this as any)[this.apiKey[this.type]]({
      project_id: this.comicId,
      user_id: this.userId,
    })).result;
    this.search();
  }

  private mounted() {
    this.chartInstance = echarts.init(document.getElementById(this.chartId), 'light');
  }

  private changeTimeFrame(val: any) {
    const start_time = val ? val[0] : '';
    const end_time = val ? val[1] : '';
    if (start_time && end_time) {
      const diff = dayjs(end_time).diff(start_time, this.timeOperate);
      if (diff > 11) {
        // this.$message.error(`时间范围不能超过12${this.formData.date_type === 1 ? '周' : '月'}`);
        // this.timeRange = [this.formData.start_time, this.formData.end_time];
        // return;
      }
    }
    this.formData.start_time = val ? val[0] : '';
    this.formData.end_time = val ? val[1] : '';
  }

  // 设置初始时间范围
  private setInitTimeRange() {
    this.timeRange = [
      dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      dayjs().subtract(1, 'day').format('YYYY-MM-DD')
    ];
    this.changeTimeFrame(this.timeRange);
  }

  private async search() {
    this.chartData = await this.getData(this.userId);
    this.doSetData();
  }

  private async getData(userId: number | null) {
    this.chartInstance.showLoading();
    const options = this.getSearchOptions(userId);
    const { result } = await (this as any)[this.apiKeyData[this.type]](options);
    if (this.type === 1) {
      result.map((item: any) => { // 创作方不显示姓名
        item.user_name = '';
      });
    }
    this.chartInstance.hideLoading();
    return result;
  }

  private getSearchOptions(userId: number | null) {
    const options = { ...this.formData, project_id: this.comicId };
    if (this.type === 2) { // 管理方需要传用户id
      options.user_id = userId;
    }
    return options;
  }

  // 监听筛选条件变化
  private initWatch() {
    for (const i of this.watchItems) {
      this.$watch(i, () => {
        if (this.searching) {
          return;
        }
        this.searching = true;
        this.$nextTick(async () => {
          this.tabPosition = '1';
          await this.search();
          this.searching = false;
        });
      });
    }
  }

  private installData(data: any): any {
    const temp: any = {};
    data.map((item: any) => {
      const re = temp[item.user_id];
      if (re) {
        re.unshift(item);
      } else {
        temp[item.user_id] = [item];
      }
    });
    return temp;
  }

  // 默认展示环节数
  private setData(result: any, type = 'num') {
    if (this.chartInstance) {
      this.chartInstance.clear();
    }
    const data = this.installData(result);
    const source: any = [['product'], [], [], [], [], [], [], [], [], [], [], [], []];
    const series: any = [];
    let flag: boolean = false;
    Object.keys(data).map((key: any, dataIndex: number) => {
      source[0].push(data[key][0].user_name || this.defaultTitle);
      series.push({ type: 'line', color: this.colors[dataIndex] });
      data[key].map((itemData: any, itemIndex: number) => {
        if (!flag) {
          source[itemIndex + 1].push(itemData.time);
        }
        source[itemIndex + 1].push(itemData[type]);
      });
      flag = true;
    });

    this.chartInstance.setOption(
      {
        legend: {},
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source
        },
        xAxis: { type: 'category' },
        yAxis: {},
        grid: {
          left: 30
        },
        series
      }
    );
  }

  @Watch('tabPosition')
  private changePosition() {
    this.doSetData();
  }

  private doSetData() {
    this.setData(this.chartData, this.tabPosition === '1' ? 'num' : 'cell_number');
  }

  // 清除成员对比
  private clearStaff() {
    this.staffIds = [];
    for (let i = this.chartData.length - 1; i >= 0; i--) {
      if (this.chartData[i].user_id !== this.userId) {
        this.chartData.splice(i, 1);
      }
    }
    this.staffIdMap = {};
    this.doSetData();
  }

  // 清除指定人员对比
  private clearStaffSingle(userId: number) {
    for (let i = this.chartData.length - 1; i >= 0; i--) {
      if (this.chartData[i].user_id === userId) {
        this.chartData.splice(i, 1);
      }
    }
    delete this.staffIdMap[userId];
    this.doSetData();
  }

  private changScope() {
    this.setInitTimeRange();
  }

  // 添加对比成员
  private async diffStaffChange() {
    this.staffIds.map(async (id: any) => {
      if (!this.staffIdMap[id]) {
        this.staffIdMap[id] = id;
        const result = await this.getData(id);
        this.chartData.push(...result);
        this.doSetData();
      }
    });

    Object.keys(this.staffIdMap).map((key: any) => {
      const userId = this.staffIdMap[key];
      if (!this.staffIds.includes(userId)) {
        this.clearStaffSingle(userId);
      }
    });
  }

  private exportExcel() {
    openUrl(`/api/${this.apiUrls[this.type]}?export=1`, this.getSearchOptions(this.userId));
  }
}
